var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect } from "react";
import LoaderContent from "./LoaderContent";
var useTimeout = function (timeoutDuration, isLoading, onTimeout) {
    useEffect(function () {
        var timer = isLoading && onTimeout ? setTimeout(onTimeout, timeoutDuration) : null;
        return function () {
            if (timer)
                clearTimeout(timer);
        };
    }, [isLoading, onTimeout, timeoutDuration]);
};
var useFullScreenEffect = function (fullScreen, isLoading) {
    useEffect(function () {
        if (fullScreen) {
            if (isLoading) {
                document.documentElement.setAttribute("data-fr-scrolling", "false");
            }
            else {
                document.documentElement.removeAttribute("data-fr-scrolling");
            }
        }
        return function () {
            if (fullScreen) {
                document.documentElement.removeAttribute("data-fr-scrolling");
            }
        };
    }, [fullScreen, isLoading]);
};
var LoaderBlock = forwardRef(function (_a, ref) {
    var isLoading = _a.isLoading, ariaLive = _a.ariaLive, size = _a.size, label = _a.label, hideLabel = _a.hideLabel, onTimeout = _a.onTimeout, _b = _a.timeoutDuration, timeoutDuration = _b === void 0 ? 3000 : _b, buttons = _a.buttons, stopAnimation = _a.stopAnimation, fullScreen = _a.fullScreen, children = _a.children, className = _a.className, style = _a.style, otherProps = __rest(_a, ["isLoading", "ariaLive", "size", "label", "hideLabel", "onTimeout", "timeoutDuration", "buttons", "stopAnimation", "fullScreen", "children", "className", "style"]);
    useTimeout(timeoutDuration, isLoading, onTimeout);
    useFullScreenEffect(fullScreen, isLoading);
    var loaderBlockClass = "ssg-loader-block";
    if (className) {
        loaderBlockClass += " ".concat(className);
    }
    return (React.createElement("div", __assign({}, otherProps, { ref: ref, className: loaderBlockClass, "aria-busy": isLoading, "aria-live": ariaLive, style: style }), fullScreen ? (React.createElement(React.Fragment, null,
        children,
        isLoading ? (React.createElement("div", { className: "ssg-loader-block__modal" },
            React.createElement(LoaderContent, { size: size, label: label, hideLabel: hideLabel, stopAnimation: stopAnimation }, buttons))) : undefined)) : (React.createElement(React.Fragment, null, isLoading ? (React.createElement(LoaderContent, { size: size, label: label, hideLabel: hideLabel, stopAnimation: stopAnimation }, buttons)) : (children)))));
});
export default LoaderBlock;
